const header = () => {
    const toggles = document.querySelectorAll('.header-nav-toggle')
    const nav = document.querySelector('.header-nav')
  
    if (toggles !== null && nav !== null) {
      toggles.forEach(toggle => {
        toggle.addEventListener('click', () => {
          nav.classList.toggle('header-nav--active')
        })
      })
    }

    const internationalMenuContainer = document.querySelector('.header-nav-list__int-link');
    const internationalMenuLink = document.querySelector('.header-nav-list__int-link .header-nav-list__link');
    const internationalSubMenuContainer = document.querySelector('.header-nav-list__int-link .sub-nav__container');
    
    const toggleInternationalMenu = (showSubMenu) => {
      internationalMenuLink.ariaExpanded = showSubMenu;
      if ( (showSubMenu !== undefined && !showSubMenu  ) || internationalMenuContainer.classList.contains('open') ) {
        internationalMenuContainer.classList.remove('open');
      } else {
        internationalMenuContainer.classList.add('open');
      }
    }

    if( internationalMenuLink ) {
      internationalMenuLink.addEventListener('click', (e) => {
        e.preventDefault();
        toggleInternationalMenu();
      });
      internationalMenuLink.addEventListener('mouseover', () => {
        toggleInternationalMenu(true);
      });
      internationalMenuLink.addEventListener('mouseout', () => {
        toggleInternationalMenu(false);
      });
    }
    if ( internationalSubMenuContainer ) {
      internationalSubMenuContainer.addEventListener('mouseover', () => {
        toggleInternationalMenu(true);
      });
      internationalSubMenuContainer.addEventListener('mouseout', () => {
        toggleInternationalMenu(false);
      });
    }
    
  }
  
  function init() {
    header()
  }
  
  export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/header.js